// extracted by mini-css-extract-plugin
module.exports = {"btn":"startEnd_btn__3UGNl"};